import { useTheme, type ThemeChoice } from './ThemeProvider'

/**
 * Selector de tema con 3 estados (§5.5 SRS).
 * Usado en el AccountMenu (zona inferior del sidebar) y opcionalmente en Configuración.
 */

const OPTIONS: { value: ThemeChoice; label: string; icon: string }[] = [
  { value: 'light', label: 'Claro', icon: '☀️' },
  { value: 'dark', label: 'Oscuro', icon: '🌙' },
  { value: 'system', label: 'Sistema', icon: '💻' },
]

export function ThemeToggle() {
  const { choice, setChoice } = useTheme()

  return (
    <div role="group" aria-label="Tema visual" className="theme-toggle">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          aria-pressed={choice === opt.value}
          className={choice === opt.value ? 'theme-toggle__btn active' : 'theme-toggle__btn'}
          onClick={() => setChoice(opt.value)}
          title={opt.label}
        >
          <span aria-hidden="true">{opt.icon}</span>
          <span className="theme-toggle__label">{opt.label}</span>
        </button>
      ))}
    </div>
  )
}
